'use strict';

angular.module('imagetrend.components')
    .controller('hlpNumberController', ['$scope', '$timeout', 'Format', 'Validation', function ($scope, $timeout, Format, Validation) {
        
        var validationTimeout = $timeout(function () {
            if (!$scope.requiredText) { $scope.requiredText = 'Please enter a ' + Format.label(($scope.label || $scope.name)) }

            if ($scope.innerForm !== undefined) {
                if ($scope.validation) {
                    Validation.validateQuestion($scope.innerForm.number, $scope.validation, $scope.ngModel);
                }
                if ($scope.question !== undefined && $scope.question.answer !== undefined) {
                    $scope.question.answer.invalid = !isEmpty($scope.innerForm.number.$error);
                }
            }
        });

        $scope.$on('$destroy', function () {
            $timeout.cancel(validationTimeout);
        });

        $scope.keyPress = function (event) {
            var charCode = (event.which) ? event.which : event.keyCode;

            if(!((charCode >= 48 && charCode <= 57) || (charCode == 46 && !$scope.integerOnly) || (charCode == 45 && !$scope.positiveOnly && !$scope.integerOnly) || charCode == 8 )){
                event.preventDefault();
            }
        }
    }])
    .directive('hlpNumber', ['Format', 'Validation', function (Format, Validation) {
        return {
            restrict: 'AE',
            scope: {
                ngModel: '=',
                question: '=',
                validation: '=?',

                //attributes
                name: '@?',
                id: '@?',
                classes: '@?',
                min: '@?',
                max: '@?',
                step: '@?',
                modal: '@?',

                //required
                isRequired: '=?',
                requiredText: '@?',
                integerOnly: '@?',
                positiveOnly: '@?',
                money: '@?',

                //disabled
                isDisabled: '=?',

                //label
                showLabel: '@?',
                label: '@?',
                title: '@?',

                //instructions
                instructions: '@?',
                pdf: '=?'
            },
            replace: true,
            transclude: true,
            require: 'ngModel',
            templateUrl: 'templates/number/number.html',
            link: function (scope, elem, attrs, ctrl) {

                scope.timeouts = [];

                //attributes
                if (!attrs.id) { attrs.id = attrs.name; }
                if (!attrs.step) { attrs.step = '1'; }
                if (!attrs.modal) { attrs.modal = false; } else { if (attrs.modal == 'true') { attrs.modal = true; } else { attrs.modal = false; } }
                
                //label
                if (!attrs.label) { attrs.label = Format.label(attrs.name); }
                if (!attrs.showLabel) { attrs.showLabel = attrs.label.length > 0; } else { if (attrs.showLabel == 'true') { attrs.showLabel = true; } else { attrs.showLabel = false; } }
                if (!attrs.title) { attrs.title = attrs.label; }

                //required
                //if (!attrs.isRequired) { attrs.isRequired = false; } else { if (attrs.isRequired == 'true') { attrs.isRequired = true; } else { attrs.isRequired = false; } }
                if (!attrs.integerOnly) { attrs.integerOnly = false; } else { if (attrs.integerOnly == 'true') { attrs.integerOnly = true; } else { attrs.integerOnly = false; } }
                if (!attrs.positiveOnly) { attrs.positiveOnly = false; } else { if (attrs.positiveOnly == 'true') { attrs.positiveOnly = true; } else { attrs.positiveOnly = false; } }

                if (attrs.positiveOnly) {
                    if (!attrs.min) { attrs.min = '0'; }
                } 

                if (attrs.money == 'true') {
                    scope.pattern = /^[0-9]+(\.[0-9]{1,2})?$/;
                }
                else {
                    scope.pattern = null;
                }

                scope.onChange = function (item) {
                    scope.submitted = false;
                    ctrl.$setViewValue(item);
                    if (scope.validation) {
                        Validation.validateQuestion(scope.innerForm.number, scope.validation, scope.ngModel);
                    }
                    if (scope.question !== undefined && scope.question.answer !== undefined) {
                        scope.question.answer.invalid = !isEmpty(scope.innerForm.number.$error);
                    }
                };

                scope.submitted = false;
                scope.$on('form:submit', function () {
                    scope.submitted = true;
                });

                scope.$on('$destroy', function () {
                    scope.timeouts.forEach(function (timer) {
                        $timeout.cancel(timer);
                    });
                });
            },
            controller: 'hlpNumberController'
        };
    }])
;